<template>
  <div id="Image"></div>
</template>

<script setup>
import p5 from 'p5'
import {ref, reactive, watchEffect, onUnmounted, onMounted} from 'vue'
import defaultValue from "@/utils/defaultValue"
import freeImg from "@/utils/freeImg";
import colorTool from "@/utils/colorTool";

const {freeImages} = freeImg()
const {defaultWidth, defaultHeight} = defaultValue()

const {changeToRgb} = colorTool()

const props = defineProps(['currentValue', 'effectTheme', 'controlMode'])

const effectThemeData = reactive(props.effectTheme)
let canvasWrap = ref('stop')

let backgroundColor = ref('rgb(0,0,0)')
let backgroundImage = ref ('')
let imagePathType = ref('')
let imgUrl = ref('')
const imageAnimate = (sketch) => {
  let bg
  let cw = defaultWidth.value
  let ch = defaultHeight.value
  let vid

  sketch.setup = function() {
    bg = ''
    vid = ''
    sketch.createCanvas(cw, ch);
    if (
        imagePathType.value !== 'gif' &&
        imagePathType.value !== 'mp4' &&
        imagePathType.value !== 'webm' &&
        imgUrl.value &&
        imgUrl.value !== null &&
        imgUrl.value !== ''
    ) bg = sketch.loadImage(imgUrl.value)
    // 若 imgUrl.value .gif
    if (
        imagePathType.value === 'gif' &&
        imgUrl.value &&
        imgUrl.value !== null &&
        imgUrl.value !== ''
    ) {
      bg = sketch.createImg(imgUrl.value)
      bg.style('background-color', `${backgroundColor.value}`)
      // 設置 背景圖 position
      bg.size(cw, ch)
      bg.position(0,0)
      // 將 canvas background 切換為 透明
      sketch.background(255, 255, 255, 0)
    }
    // 若 imgUrl.value .mp4 or .webm
    if (
        imagePathType.value === 'mp4' &&
        imgUrl.value &&
        imgUrl.value !== null &&
        imgUrl.value !== '' ||
        imagePathType.value === 'webm' &&
        imgUrl.value &&
        imgUrl.value !== null &&
        imgUrl.value !== ''
    ) {
      // mp4
      vid = sketch.createVideo(imgUrl.value)
      vid.style('background-color', `${backgroundColor.value}`)
      vid.size(sketch.width, sketch.height);
      vid.position(0,0)
      vid.volume(0);
      vid.loop()
      sketch.background(backgroundColor.value)
    }

  }
  sketch.draw = function () {
    // 若 imgUrl.value 不是 .gif or .mp4
    if (
        imagePathType.value !== 'gif' &&
        imagePathType.value !== 'mp4' &&
        imagePathType.value !== 'webm'
    ) {
      // 添加 背景色
      sketch.background(backgroundColor.value)
      // 添加 背景圖
      if (imgUrl.value && imgUrl.value !== null && imgUrl.value !== '') sketch.image(bg, 0, 0, sketch.width, sketch.height)
    }

    // sketch.push()
    // sketch.textSize(20)
    // sketch.textWrap(sketch.CHAR)
    // sketch.fill('red')
    // sketch.text(imgUrl.value, 0, 0, sketch.width)
    // sketch.pop()
  }
}

function initAnimate () {
  if (canvasWrap.value !== 'stop') {
    canvasWrap.value.remove()
    canvasWrap.value = 'stop'
  }
}


watchEffect(() => {
  // 清除 canvasWrap
  const {
    Path,
    BackgroundColor
  } = effectThemeData

  // 背景色
  let bgColor = typeof BackgroundColor === "object" && BackgroundColor.length > 0 ? changeToRgb(BackgroundColor) : 'rgb(0,0,0)'

  // 背景圖
  if (
      backgroundImage.value !== Path ||
      backgroundColor.value !== bgColor
  ) {
    backgroundColor.value = bgColor
    imagePathType.value = ''
    backgroundImage.value = Path
    if (backgroundImage.value !== '') {
      if (props.controlMode && props.controlMode.toString() === 'true') {
        const pathSplit = Path.split('.')
        imgUrl.value = freeImages[pathSplit[0]]
        imagePathType.value = pathSplit[1]
      } else {
        imgUrl.value = backgroundImage.value.split('#')[0]
        if (imgUrl.value.endsWith('.mp4')) imagePathType.value = 'mp4'
        else if (imgUrl.value.endsWith('.webm')) imagePathType.value = 'webm'
        else if (imgUrl.value.endsWith('.gif')) imagePathType.value = 'gif'
      }
    } else {
      imgUrl.value = ''
      imagePathType.value = ''
    }

    // 背景色, 背景圖 需重置動畫
    if (canvasWrap.value !== 'stop') {
      initAnimate()
      canvasWrap.value = new p5(imageAnimate, 'Image')
    }
  }

})


 onMounted( async() => {
   if (canvasWrap.value === 'stop') canvasWrap.value =  new p5(imageAnimate, 'Image')
})

onUnmounted(() => {
  backgroundImage.value = ''
  imgUrl.value = ''
  imagePathType.value = ''
  backgroundColor.value = 'rgb(0,0,0)'
  initAnimate()
})

</script>
